import { PORTAL_URL } from '@/environment'
import {
  LINK_TARGET_DEFAULT,
  LINK_TARGET_NEW_TAB,
} from '@/helpers/constants.js'
import Detect from '@attensi/detect'
import { redirect } from '@attensi/redirect'

export const getPortalLink = () => {
  return redirect.createUrl({
    href: PORTAL_URL,
  })
}

export const getPortalLinkTarget = () => {
  const isMobile = Detect.isPortalApp && Detect.isAndroid
  return isMobile ? LINK_TARGET_DEFAULT : LINK_TARGET_NEW_TAB
}
